/**
 * Ruleset version for the recommendation engine
 * 
 * Version bump rules:
 * - PATCH: Wording tweaks, minor copy changes, no logic changes
 * - MINOR: Threshold adjustments, scoring changes, new fields (backwards compatible)
 * - MAJOR: Structural changes, breaking API changes, fundamental logic overhaul
 */
export const RULESET_VERSION = "1.0.0";
